"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _without = _interopRequireDefault(require("lodash/without"));

var _PlaylistItem = _interopRequireDefault(require("./PlaylistItem"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  _setPrototypeOf(subClass.prototype, superClass && superClass.prototype);

  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.getPrototypeOf || function _getPrototypeOf(o) {
    return o.__proto__;
  };

  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Playlist =
/*#__PURE__*/
function (_React$PureComponent) {
  function Playlist(props) {
    var _this;

    _classCallCheck(this, Playlist);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Playlist).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      refs: {}
    });

    _this.handleItemSelected = _this.handleItemSelected.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(Playlist, [{
    key: "handleItemSelected",
    value: function handleItemSelected(selectedId) {
      var onSelect = this.props.onSelect;
      var refs = this.state.refs;
      var refsToUnselect = (0, _without.default)(Object.keys(refs), selectedId);
      refsToUnselect.forEach(function (mediaId) {
        refs[mediaId].current.setIsSelected(false);
      });
      if (onSelect) onSelect(selectedId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          ItemComponent = _this$props.ItemComponent,
          classContainer = _this$props.classContainer,
          media = _this$props.media,
          selectedId = _this$props.selectedId;
      var refs = this.state.refs;
      return _react.default.createElement("div", {
        className: classContainer
      }, media.map(function (medium) {
        return _react.default.createElement(ItemComponent, {
          key: medium._id,
          media: medium,
          onSelect: _this2.handleItemSelected,
          ref: refs[medium._id],
          selected: selectedId === medium._id,
          actionButtons: medium.actionButtons
        }, medium.children);
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref) {
      var media = _ref.media;
      var refs = {};
      media.forEach(function (medium) {
        refs[medium._id] = _react.default.createRef();
      });
      return {
        refs: refs
      };
    }
  }]);

  _inherits(Playlist, _React$PureComponent);

  return Playlist;
}(_react.default.PureComponent);

exports.default = Playlist;

_defineProperty(_defineProperty(Playlist, "propTypes", {
  ItemComponent: _propTypes.default.func,
  classContainer: _propTypes.default.string,
  media: _propTypes.default.array.isRequired,
  onSelect: _propTypes.default.func,
  selectedId: _propTypes.default.string
}), "defaultProps", {
  ItemComponent: _PlaylistItem.default,
  classContainer: '',
  onSelect: null,
  selectedId: ''
});